import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all form types
export const getFormType = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-type`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-type:", error.response?.data || error);
    throw error;
  }
};

// GET a single form type
export const getFormTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-type/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-type:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new form type
export const createFormType = async (formTypeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-type`, formTypeData);
    return response.data;
  } catch (error) {
    console.error("Error creating form-type:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing form type
export const updateFormType = async (id, formTypeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-type/${id}`, formTypeData);
    return response.data;
  } catch (error) {
    console.error("Error updating form-type:", error.response?.data || error);
    throw error;
  }
};

// DELETE a form type
export const deleteFormType = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-type/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting form-type:", error.response?.data || error);
    throw error;
  }
};
